module.exports = __webpack_public_path__ + "static/img/share_img5.74009009.png";